

window.addEventListener("load", function () {
    if ($('#MS__wrapper.iframe').length > 0) return;

   new Swiper(".swiper-images", {
      pagination: {
         el: ".swiper-images-pagination",
         clickable: true,
      },
      autoplay: {
         delay: 5000, // 4s chuyển slide
      },
   });
});
